module.exports = __webpack_public_path__ + "static/media/film-placeholder.d1b4253f.png";